(function () {
  'use strict';

  var emailInvalidMessage = 'Please enter a valid email address (e.g. name@example.com).';
  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var activeOverlay = null;
  var activeScope = null;
  var overlayPlacement = null;
  var pendingSuccessCheckDone = false;

  function getProductScope(element) {
    if (!element) return document;
    return element.closest('.product-section') || element.closest('.modal--quick-shop') || document;
  }

  function getOverlay(scope) {
    if (!scope) return null;
    return scope.querySelector('.request-quote-overlay');
  }

  function findOverlayByProductId(productId) {
    if (!productId) return null;

    var match = null;
    document.querySelectorAll('.request-quote-overlay').forEach(function (overlay) {
      if (match) return;
      var scope = getProductScope(overlay);
      var data = getProductData(scope);
      if (String(data.productId) === String(productId)) {
        match = { overlay: overlay, scope: scope };
      }
    });
    return match;
  }

  function getOverlayElements(overlay) {
    if (!overlay) return null;

    return {
      overlay: overlay,
      form: overlay.querySelector('[id^="request-quote-form"]'),
      productDisplayField: overlay.querySelector('[id^="request-quote-product-field"]'),
      productHiddenField: overlay.querySelector('[id^="request-quote-product-hidden"]'),
      emailInput: overlay.querySelector('[id^="request-quote-email"]'),
      emailErrorEl: overlay.querySelector('[id^="request-quote-email-error"]'),
      nameInput: overlay.querySelector('[id^="request-quote-name"]'),
      messageInput: overlay.querySelector('[id^="request-quote-message"]'),
      submitBtn: overlay.querySelector('[id^="request-quote-submit"]'),
      formWrap: overlay.querySelector('[id^="request-quote-form-wrap"]'),
      successEl: overlay.querySelector('[id^="request-quote-success"]')
    };
  }

  function getProductData(scope) {
    var dataEl = scope.querySelector('[id^="request-quote-product-data"]');
    if (!dataEl) return {};

    try {
      return JSON.parse(dataEl.textContent);
    } catch (e) {
      return {};
    }
  }

  function getVariants(scope) {
    var variantJson = scope.querySelector('[data-variant-json]');
    if (!variantJson) return [];

    try {
      return JSON.parse(variantJson.textContent);
    } catch (e) {
      return [];
    }
  }

  function getCurrentVariant(scope) {
    var currentJson = scope.querySelector('[data-current-variant-json]');
    if (currentJson) {
      try {
        return JSON.parse(currentJson.textContent);
      } catch (e) {}
    }

    var select = scope.querySelector('[data-product-select]');
    var variants = getVariants(scope);

    if (select && variants.length) {
      return variants.find(function (v) {
        return String(v.id) === String(select.value);
      }) || variants[0];
    }

    return variants[0] || null;
  }

  function getProductDisplayName(productData, variant) {
    var title = productData.productTitle || '';
    if (!variant || variant.title === 'Default Title') return title;
    return title + ' - ' + variant.title;
  }

  function syncProductFields(scope, els) {
    var productData = getProductData(scope);
    var variant = getCurrentVariant(scope);
    if (!variant) return;

    var displayName = getProductDisplayName(productData, variant);

    if (els.productDisplayField) {
      els.productDisplayField.value = displayName;
    }

    if (els.productHiddenField) {
      els.productHiddenField.value = 'Quote request for: ' + displayName;
    }
  }

  function clearContactPostedUrl() {
    if (window.location.search.indexOf('contact_posted') === -1) return;

    var url = new URL(window.location.href);
    url.searchParams.delete('contact_posted');
    var nextUrl = url.pathname + url.search + url.hash;
    window.history.replaceState({}, '', nextUrl);
  }

  function clearPendingQuoteStorage() {
    sessionStorage.removeItem('requestQuoteSubmitted');
    sessionStorage.removeItem('requestQuoteProductId');
    sessionStorage.removeItem('requestQuoteProductHandle');
  }

  function storePendingQuoteSubmission(productData) {
    sessionStorage.setItem('requestQuoteSubmitted', '1');
    sessionStorage.setItem('requestQuoteProductId', String(productData.productId || ''));
    sessionStorage.setItem('requestQuoteProductHandle', productData.productHandle || '');
  }

  function isValidEmail(value) {
    if (!value || !String(value).trim()) return false;

    var email = String(value).trim();
    if (!emailPattern.test(email)) return false;

    var domain = email.split('@')[1];
    if (!domain || domain.indexOf('.') === -1) return false;

    var domainParts = domain.split('.');
    var tld = domainParts[domainParts.length - 1];
    return Boolean(tld && tld.length >= 2);
  }

  function showEmailError(els, message) {
    if (!els.emailInput || !els.emailErrorEl) return;

    els.emailInput.classList.add('is-invalid');
    els.emailInput.setAttribute('aria-invalid', 'true');
    els.emailErrorEl.textContent = message || emailInvalidMessage;
    els.emailErrorEl.hidden = false;
  }

  function clearEmailError(els) {
    if (!els.emailInput || !els.emailErrorEl) return;

    els.emailInput.classList.remove('is-invalid');
    els.emailInput.removeAttribute('aria-invalid');
    els.emailErrorEl.textContent = '';
    els.emailErrorEl.hidden = true;
  }

  function validateEmailField(els, showError) {
    if (!els.emailInput) return true;

    var value = els.emailInput.value;
    if (!value.trim()) {
      if (showError) showEmailError(els, emailInvalidMessage);
      return false;
    }

    if (!isValidEmail(value)) {
      if (showError) showEmailError(els, emailInvalidMessage);
      return false;
    }

    clearEmailError(els);
    return true;
  }

  function isFormValid(els) {
    var isNameValid = els.nameInput && els.nameInput.value.trim().length > 0;
    var isMessageValid = els.messageInput && els.messageInput.value.trim().length > 0;
    var isEmailValid = els.emailInput && isValidEmail(els.emailInput.value);
    return Boolean(isNameValid && isEmailValid && isMessageValid);
  }

  function updateSubmitButtonState(els) {
    if (!els.submitBtn || els.submitBtn.classList.contains('is-loading')) return;
    els.submitBtn.disabled = !isFormValid(els);
  }

  function resetSubmitButton(els) {
    if (!els.submitBtn) return;
    els.submitBtn.classList.remove('is-loading');
    updateSubmitButtonState(els);
  }

  function resetAfterSuccess(scope, els) {
    if (els.formWrap) els.formWrap.hidden = false;
    if (els.successEl) els.successEl.hidden = true;
    if (els.messageInput) els.messageInput.value = '';
    clearEmailError(els);
    resetSubmitButton(els);
    syncProductFields(scope, els);
    clearContactPostedUrl();
    clearPendingQuoteStorage();
    updateSubmitButtonState(els);
  }

  function moveOverlayToBody(overlay) {
    if (!overlay || overlay.parentElement === document.body) return;

    overlayPlacement = {
      parent: overlay.parentElement,
      nextSibling: overlay.nextSibling
    };
    document.body.appendChild(overlay);
  }

  function restoreOverlayPlacement(overlay) {
    if (!overlay || !overlayPlacement || !overlayPlacement.parent) return;

    overlayPlacement.parent.insertBefore(overlay, overlayPlacement.nextSibling);
    overlayPlacement = null;
  }

  function openModal(overlay, scope, fromUserAction) {
    var els = getOverlayElements(overlay);
    if (!els) return;

    if (fromUserAction && els.successEl && !els.successEl.hidden) {
      resetAfterSuccess(scope, els);
    }

    syncProductFields(scope, els);
    moveOverlayToBody(overlay);
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('request-quote-open');
    activeOverlay = overlay;
    activeScope = scope;
    updateSubmitButtonState(els);

    if (fromUserAction && els.nameInput) {
      setTimeout(function () {
        els.nameInput.focus();
      }, 100);
    }
  }

  function closeModal(overlay) {
    if (!overlay) return;

    var scope = getProductScope(overlay);
    var els = getOverlayElements(overlay);
    var wasSuccess = els && els.successEl && !els.successEl.hidden;

    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('request-quote-open');
    restoreOverlayPlacement(overlay);

    if (activeOverlay === overlay) {
      activeOverlay = null;
      activeScope = null;
    }

    if (wasSuccess && els) {
      resetAfterSuccess(scope, els);
    }
  }

  function showQuoteSuccess(overlay, scope) {
    var els = getOverlayElements(overlay);
    if (!els) return;

    if (els.formWrap) els.formWrap.hidden = true;
    if (els.successEl) els.successEl.hidden = false;
    openModal(overlay, scope, false);
  }

  function getQuoteStrings() {
    return window.requestQuoteStrings || {
      success: 'Thank you! Your quote request has been submitted.',
      description: "Fill out the form below and we'll get back to you with pricing information.",
      close: 'Close'
    };
  }

  function showGlobalQuoteSuccess() {
    var strings = getQuoteStrings();
    var overlay = document.getElementById('request-quote-global-overlay');

    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'request-quote-global-overlay';
      overlay.className = 'request-quote-overlay';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.innerHTML =
        '<div class="request-quote-modal" role="dialog" aria-modal="true">' +
          '<div class="request-quote-modal__inner">' +
            '<button type="button" class="close request-quote-close" aria-label="' + strings.close + '">&times;</button>' +
            '<p class="request-quote-description">' + strings.description + '</p>' +
            '<div class="completed_message alert alert-success">' +
              strings.success +
              ' <a href="#" class="request-quote-close">' + strings.close + '</a>' +
            '</div>' +
          '</div>' +
        '</div>';
      document.body.appendChild(overlay);
    }

    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('request-quote-open');
    activeOverlay = overlay;
    activeScope = null;
  }

  function responseIndicatesSuccess(response, html) {
    if (response && (response.ok || response.redirected)) return true;
    if (response && response.url && response.url.indexOf('contact_posted') !== -1) return true;
    if (html && (html.indexOf('contact_posted') !== -1 || html.indexOf('form-posted-success') !== -1)) return true;
    return false;
  }

  function submitQuoteForm(els) {
    var formAction = els.form.getAttribute('action') || '/contact';
    if (formAction.indexOf('#') !== -1) {
      formAction = formAction.split('#')[0];
    }

    return fetch(formAction, {
      method: 'POST',
      body: new FormData(els.form),
      credentials: 'same-origin',
      redirect: 'follow',
      headers: {
        Accept: 'text/html,application/xhtml+xml'
      }
    }).then(function (response) {
      if (responseIndicatesSuccess(response)) return true;

      return response.text().then(function (html) {
        if (responseIndicatesSuccess(response, html)) return true;
        throw new Error('Quote request failed');
      });
    });
  }

  function finishPendingQuoteSuccess(overlay, scope) {
    clearPendingQuoteStorage();
    clearContactPostedUrl();

    if (overlay && scope) {
      ensureOverlayInitialized(overlay);
      showQuoteSuccess(overlay, scope);
      return;
    }

    showGlobalQuoteSuccess();
  }

  function handlePendingQuoteSuccess() {
    var urlHasContactPosted = window.location.search.indexOf('contact_posted') > -1;
    var pendingQuoteSubmit = sessionStorage.getItem('requestQuoteSubmitted') === '1';

    document.querySelectorAll('.request-quote-overlay').forEach(function (overlay) {
      var scope = getProductScope(overlay);
      var productData = getProductData(scope);

      if (productData.submitted) {
        clearPendingQuoteStorage();
        document.body.classList.add('request-quote-open');
      } else if (productData.hasErrors || overlay.classList.contains('is-open')) {
        document.body.classList.add('request-quote-open');
      }
    });

    if (!pendingQuoteSubmit || !urlHasContactPosted) return;
    if (pendingSuccessCheckDone) return;

    var productId = sessionStorage.getItem('requestQuoteProductId');
    var productHandle = sessionStorage.getItem('requestQuoteProductHandle');
    var match = findOverlayByProductId(productId);

    if (match) {
      pendingSuccessCheckDone = true;
      finishPendingQuoteSuccess(match.overlay, match.scope);
      return;
    }

    if (productHandle && window.theme && typeof window.theme.preloadProductModal === 'function') {
      if (!window.requestQuotePreloadPending) {
        window.requestQuotePreloadPending = true;
        window.theme.preloadProductModal(productHandle, productId, null, function () {
          window.requestQuotePreloadPending = false;
          pendingSuccessCheckDone = true;
          var holder = document.getElementById('QuickShopHolder-' + productHandle);
          var scope = holder && holder.querySelector('.product-section');
          var overlay = scope && getOverlay(scope);
          finishPendingQuoteSuccess(overlay, scope);
        });
      }
      return;
    }

    pendingSuccessCheckDone = true;
    finishPendingQuoteSuccess(null, null);
  }

  function ensureOverlayInitialized(overlay) {
    if (!overlay || overlay.dataset.rqInitialized === 'true') return;

    var scope = getProductScope(overlay);
    var els = getOverlayElements(overlay);
    if (!els) return;

    var productData = getProductData(scope);
    if (productData.emailInvalidMessage) {
      emailInvalidMessage = productData.emailInvalidMessage;
    }

    if (els.emailInput) {
      els.emailInput.addEventListener('input', function () {
        if (isValidEmail(els.emailInput.value) || !els.emailInput.value.trim()) {
          clearEmailError(els);
        }
        updateSubmitButtonState(els);
      });

      els.emailInput.addEventListener('blur', function () {
        if (els.emailInput.value.trim()) validateEmailField(els, true);
        updateSubmitButtonState(els);
      });
    }

    [els.nameInput, els.messageInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        updateSubmitButtonState(els);
      });
    });

    if (els.form) {
      els.form.addEventListener('submit', function (e) {
        syncProductFields(scope, els);

        var isEmailValid = validateEmailField(els, true);
        var isNameValid = els.nameInput && els.nameInput.value.trim().length > 0;
        var isMessageValid = els.messageInput && els.messageInput.value.trim().length > 0;

        if (!isNameValid) {
          e.preventDefault();
          resetSubmitButton(els);
          if (els.nameInput) els.nameInput.focus();
          return;
        }

        if (!isEmailValid) {
          e.preventDefault();
          resetSubmitButton(els);
          els.emailInput.focus();
          return;
        }

        if (!isMessageValid) {
          e.preventDefault();
          resetSubmitButton(els);
          if (els.messageInput) els.messageInput.focus();
          return;
        }

        var isQuickView = Boolean(scope.closest('.modal--quick-shop'));

        if (els.submitBtn) {
          els.submitBtn.classList.add('is-loading');
          els.submitBtn.disabled = true;
        }

        if (isQuickView) {
          e.preventDefault();
          submitQuoteForm(els)
            .then(function () {
              showQuoteSuccess(overlay, scope);
            })
            .catch(function () {
              resetSubmitButton(els);
              storePendingQuoteSubmission(productData);
              els.form.submit();
            });
          return;
        }

        storePendingQuoteSubmission(productData);
      });
    }

    overlay.dataset.rqInitialized = 'true';
    updateSubmitButtonState(els);
  }

  function initOverlays(root) {
    var context = root || document;
    context.querySelectorAll('.request-quote-overlay').forEach(function (overlay) {
      ensureOverlayInitialized(overlay);
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.request-quote-trigger');
    if (!trigger) return;

    var scope = getProductScope(trigger);
    var overlay = getOverlay(scope);
    if (!overlay) return;

    e.preventDefault();
    e.stopPropagation();
    ensureOverlayInitialized(overlay);
    openModal(overlay, scope, true);
  });

  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('.request-quote-close');
    if (!closeBtn) return;

    var overlay = closeBtn.closest('.request-quote-overlay');
    if (!overlay) return;

    e.preventDefault();
    closeModal(overlay);
  });

  document.addEventListener('click', function (e) {
    if (!e.target.classList || !e.target.classList.contains('request-quote-overlay')) return;
    if (!e.target.classList.contains('is-open')) return;
    closeModal(e.target);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && activeOverlay && activeOverlay.classList.contains('is-open')) {
      closeModal(activeOverlay);
    }
  });

  document.addEventListener('variant:change', function (e) {
    if (!activeOverlay || !activeScope) return;

    var variant = e.detail && e.detail.variant;
    if (!variant) return;

    var els = getOverlayElements(activeOverlay);
    if (!els) return;

    var productData = getProductData(activeScope);
    var displayName = getProductDisplayName(productData, variant);

    if (els.productDisplayField) {
      els.productDisplayField.value = displayName;
    }

    if (els.productHiddenField) {
      els.productHiddenField.value = 'Quote request for: ' + displayName;
    }
  });

  document.addEventListener('quickview:loaded', function () {
    initOverlays(document);
    handlePendingQuoteSuccess();
  });

  function boot() {
    initOverlays(document);
    handlePendingQuoteSuccess();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
